var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#0059F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4186 26.5874C13.7508 26.9196 14.275 27.2001 15.1018 27.2001C15.8842 27.2001 16.9473 26.9492 18.3794 26.2331L24.6984 23.0736C26.2634 22.2911 27.1271 21.1985 27.1271 20.0026C27.1271 18.8067 26.2634 17.7142 24.691 16.9317L18.372 13.7722C15.4487 12.3032 14.0609 12.7682 13.4186 13.4179C12.769 14.0601 12.304 15.4479 13.773 18.3786L14.4152 19.6557C14.4964 19.8255 14.4964 20.1798 14.4152 20.3496L13.773 21.6267C12.3113 24.5574 12.769 25.9378 13.4186 26.5874ZM14.2011 14.2003C14.3931 14.0084 14.7031 13.9124 15.1018 13.9124C15.7883 13.9124 16.7553 14.2003 17.8774 14.7614L24.1964 17.9135C25.3554 18.4893 26.0198 19.2497 26.0198 19.9953C26.0198 20.7408 25.3628 21.5012 24.2038 22.077L17.8848 25.2365C16.1131 26.1224 14.7326 26.3364 14.2011 25.7976C13.6623 25.266 13.8763 23.893 14.7622 22.1213L15.4044 20.8442C15.4481 20.7555 15.4837 20.6585 15.5112 20.5562H19.1098C19.4125 20.5562 19.6635 20.3052 19.6635 20.0025C19.6635 19.6999 19.4125 19.4489 19.1098 19.4489H15.5111C15.4836 19.3467 15.4481 19.2497 15.4044 19.1611L14.7622 17.8766C13.8763 16.1123 13.6623 14.7319 14.2011 14.2003Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.cdfdceb3561dd17fba1160ec28f981f6.svg";
export { ForwardRef as ReactComponent };